module.exports = __webpack_public_path__ + "img/meetingLogo.bb155d3d.png";